import { ReporteEstadoResultado } from '@/components/reportes/ReporteEstadoResultado'
import type { Periodo } from '@/lib/periodo-reporte'

/** Estado de Resultado del período del filtro global, con grupos y categorías plegables. */
export function EstadoResultadoPeriodo({ periodo }: { periodo: Periodo }) {
  return (
    <section aria-label="Estado de Resultado">
      <ReporteEstadoResultado periodo={periodo} />
    </section>
  )
}
